import type { GetterTree, Store } from "vuex";
import type { State } from "@/store/state";
import type { AdminState } from "./state";
import type { IUserProfile } from "@/interfaces";

export const getters: GetterTree<AdminState, State> = {
  adminUsers: (state): IUserProfile[] => state.users,
  adminOneUser:
    (state) =>
    (userId: number): IUserProfile => {
      const filteredUsers = state.users.filter((user) => user.id === userId);
      if (filteredUsers.length > 0) {
        return { ...filteredUsers[0] };
      }
    },
  users: (state): IUserProfile[] => state.users,
};

const NS = "admin/";

export const readAdminOneUser = (store: Store<State>) =>
  store.getters[`${NS}adminOneUser`] as (userId: number) => IUserProfile;
export const readAdminUsers = (store: Store<State>) =>
  store.getters[`${NS}adminUsers`] as IUserProfile[];
export const readUsers = (store: Store<State>) =>
  store.getters[`${NS}users`] as IUserProfile[];
